import React, { useContext } from "react";
import PropTypes from "prop-types";
import { VariantContextData } from "../variants/VariantBuilderContext";
import VariantProfile from "../variants/VariantProfile";
import Step from "./Step";
import VariantTheme from "../variants/VariantTheme";
import VariantClose from "../variants/VariantClose";

const StepBuilder = (props) => {
  const [contextData, builder] = useContext(VariantContextData);
  let selected = builder.selected();
  let cta = props.cta;
  let variant = props.variant;
  let step = props.step || props.variant.steps[props.step.id];
  let max_width = null;

  if (props.cta.cta_type !== "page") {
    if (
      props.variant.options["container-width"] == "310px" ||
      (!props.variant.options["container-width"] &&
        props.cta.cta_type == "hook" &&
        props.cta.hook_type == "vertical")
    ) {
      max_width = "310px";
    } else if (
      ["small", "500px"].includes(props.variant.options["container-width"])
    ) {
      max_width = "500px";
    } else if (
      ["regular", "700px"].includes(props.variant.options["container-width"])
    ) {
      max_width = "700px";
    } else if (
      ["large", "900px"].includes(props.variant.options["container-width"])
    ) {
      max_width = "900px";
    } else if (props.variant.options["container-width"] == "1200px") {
      max_width = "1200px";
    } else if (props.variant.options["container-width"] == "100%") {
      max_width = "100%";
    } else if (props.variant.options["container-width"]) {
      max_width = props.variant.options["container-width"];
    }
  }

  const containerBackground =
    contextData.device == "mobile" &&
    variant.options["container-background-mobile"]
      ? variant.options["container-background-mobile"]
      : variant.options["container-background"];

  return (
    <React.Fragment>
      <div
        id={"step-" + step.id + "-canvas"}
        data-step-id={step.id}
        step-id={step.id}
        data-position={step.position}
        className="step step-builder-wrapper"
      >
        <div
          className="row hard-center some-vertical-space"
          style={{ padding: "0 15px" }}
        >
          <div
            id={"cta_" + props.cta.id}
            className={
              "cta cf-" +
              props.cta.cta_type +
              "-" +
              props.cta[props.cta_type] +
              "_type"
            }
          >
            <div className="cf-container cf-row cf-outer-center">
              <div
                className={
                  "row hard-center canvas preview-" +
                  contextData.device +
                  (props.builder == true &&
                  selected.object_type == "steps" &&
                  selected.object_id == step.id
                    ? " editor-select"
                    : "")
                }
                data-step-id={step.id}
              >
                <div
                  className="row some-vertical-space step-toggle"
                  data-step-id={step.id}
                >
                  <h4
                    className={`step-headline text-xl font-semibold ${
                      cta.cta_type == "overlay" &&
                      containerBackground == "dark"
                        ? "text-white"
                        : "text-black"
                    } dark:text-white smooth`}
                  >
                    Step {step.position}
                    {step.options && step.options["name"]
                      ? " - " + step.options["name"]
                      : ""}
                  </h4>
                </div>
                <div
                  className="row hard-center cta-preview"
                  style={{
                    width: contextData.device == "desktop" ? max_width : null,
                    maxWidth:
                      contextData.device == "mobile" ? max_width : "100%",
                  }}
                >
                  {["hook", "overlay", "inline"].includes(
                    props.cta.cta_type
                  ) && (
                    <VariantProfile
                      variant={props.variant}
                      cta={props.cta}
                      website={props.website}
                      user={props.user}
                      builder={props.builder}
                    />
                  )}
                  <Step key={"step-" + step.id} step={step} {...props} />
                  {props.builder == true &&
                    ["overlay", "hook", "bar"].includes(cta.cta_type) && (
                      <VariantClose
                        variant={variant}
                        cta={cta}
                        website={props.website}
                        builder={props.builder}
                        device={props.device}
                      />
                    )}
                </div>
              </div>
            </div>
          </div>
        </div>
        <VariantTheme {...props} />
      </div>
    </React.Fragment>
  );
};

export default StepBuilder;
